import { createFileRoute, useParams } from '@tanstack/react-router';
import { z } from 'zod';

import { OrganizationDetailScreen } from '@/features/organizations/components/shared/OrganizationDetailScreen';
import { requirePermission } from '@/lib/guards';

const searchSchema = z.object({
  tab: z.enum(['locations', 'users']).catch('locations').optional(),
});

export const Route = createFileRoute('/_staff/admin/platform/organizations/$orgId')({
  beforeLoad: () => {
    requirePermission('org:read');
  },
  component: PlatformOrganizationDetailRoute,
  staticData: { crumb: 'Organization' },
  validateSearch: searchSchema.parse.bind(searchSchema),
});

function PlatformOrganizationDetailRoute() {
  const { orgId } = useParams({ from: '/_staff/admin/platform/organizations/$orgId' });
  return <OrganizationDetailScreen orgId={orgId} surface="platform" />;
}
